import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import {UseFormReset} from "react-hook-form";

export type PostFeedbackPayload = {
    service_id:number | string;
    message: string;
    reset: UseFormReset<any>;
};

export type PostFeedbackLoadAction = {
  type: string;
  payload: PostFeedbackPayload;
};

export type PostFeedbackData = { data: {
    description: string;
    error:string
    message:string
    status:"warning" | "success" |  "error";
  } };

const PostFeedback = new ReduxFetchState<PostFeedbackData, PostFeedbackPayload, any>(
  "postFeedback",
);

export function* watchPostFeedback(action: PostFeedbackLoadAction) {
  const { service_id,message ,reset} = action.payload;
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: PostFeedbackData = yield axios({
      url: "/api/v1/ai/service/feedback",
      method: "POST",
      headers: { lang },
      data: {
        service_id,
        message
      },
    });
    reset();
    yield put(PostFeedback.actions.loadSuccess({data:data.data}));
  } catch (e: any) {
    const backendError = e?.response?.data?.error || e?.message || "Something went wrong";
    if (e.response.data.status){
      yield put(PostFeedback.actions.loadSuccess(e?.response));
      reset();
    }else {
      alert({ message: backendError?.message[0], type: "error" });
    }
    yield put(PostFeedback.actions.loadFailure(e.message));
  }
}

export function* postFeedbackSagas() {
  yield takeEvery(PostFeedback.actionTypes.load, watchPostFeedback);
}

export function usePostFeedback() {
  const { loading, data, ...postFeedbackState } = useAppSelector(
    (state) => state.postFeedback,
  );
  const dispatch = useAppDispatch();

  const dispatchPostFeedback = useCallback(
    (data: PostFeedbackPayload) => {
      dispatch(PostFeedback.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...postFeedbackState,
    dispatchPostFeedback,
    postFeedbackLoading: loading,
    postFeedbackData: data,
  };
}

export const {
  actionTypes: postFeedbackActionsTypes,
  actions: postFeedbackActions,
  reducer: postFeedbackReducer,
} = PostFeedback;